import React from "react";

const EnterPatient = () => {
  return <div>EnterPatient</div>;
};

export default EnterPatient;
